import { Button as BaseButton, styled } from "@mui/material";

export const Button = styled(BaseButton)(
  ({ theme }) => `
  pointer-events: all;
  min-width: 0;
  padding: 0;
  background-color: ${theme.palette.common.white};
  color: ${theme.palette.common.black};
  margin-right: 0;

  width: 28px;
  height: 28px;
  
  & > svg {
    width: 20px;
    height: 20px;
  }

  &.active {
    background-color: ${theme.palette.primary.light};
    color: ${theme.palette.common.white};
  }

  &:hover:not(.active) {
    background-color: ${theme.palette.biarri.primary.lightGrey};
  }
`
);
